const IconHotel = () => {
    return (
        <svg
            width="47"
            height="47"
            viewBox="0 0 47 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13.7085 26.4375C16.9593 26.4375 19.5835 23.8133 19.5835 20.5625C19.5835 17.3117 16.9593 14.6875 13.7085 14.6875C10.4577 14.6875 7.8335 17.3117 7.8335 20.5625C7.8335 23.8133 10.4577 26.4375 13.7085 26.4375ZM13.7085 18.6042C14.7856 18.6042 15.6668 19.4854 15.6668 20.5625C15.6668 21.6396 14.7856 22.5208 13.7085 22.5208C12.6314 22.5208 11.7502 21.6396 11.7502 20.5625C11.7502 19.4854 12.6314 18.6042 13.7085 18.6042ZM37.2085 12.7292H21.5418V28.3958H5.87516V8.8125H1.9585V38.1875H5.87516V32.3125H41.1252V38.1875H45.0418V20.5625C45.0418 16.2346 41.5364 12.7292 37.2085 12.7292ZM41.1252 28.3958H25.4585V16.6458H37.2085C39.3627 16.6458 41.1252 18.4083 41.1252 20.5625V28.3958Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconHotel;
